import { render } from "./BackgroundVideo.vue?vue&type=template&id=7470c53a&scoped=true"
import script from "./BackgroundVideo.vue?vue&type=script&lang=js"
export * from "./BackgroundVideo.vue?vue&type=script&lang=js"

import "./BackgroundVideo.vue?vue&type=style&index=0&id=7470c53a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7470c53a"]])

export default __exports__